<template>
  <ul class="brand-list clearfix" :class="{'is-img-mode': showImg}">
    <li class="brand-item"
      :class="{'is-active': current === item.brandId}"
      v-for="item in list"
      :key="item.brandId"
      @click="handleBrandTap(item.brandId)">
        <div v-if="showImg" class="brand-icon" :title="item.brandName" :style="'background-image: url(' + superEncode(item.brandLogo) + ')'">
          <div v-if="item.activityText" class="active-info text-white text-center">
            {{ item.activityText }}
          </div>
        </div>
        <div v-else>
          {{ item.brandName }}
          <div v-if="item.activityText" class="active-info text-white text-center">
            {{ item.activityText }}
          </div>
        </div>
      </li>
  </ul>
</template>

<script>
export default {
  props: {
    list: Array,
    current: String,
    showImg: Boolean
  },
  methods: {
    async handleBrandTap (data) {
      this.$emit('onBrandChanged', data);
    },
    superEncode (url) {
      return encodeURI(url).replace('(', '%28').replace(')', '%29');
    }
  }
};
</script>

<style scoped>
@import 'config.css';

.brand-item {
  float: left;
  position: relative;
  margin-top: 20px;
  margin-right: 54px;
  font-size: 14px;
  cursor: pointer;
  line-height: 20px;
  border-bottom: 2px solid transparent;
  text-align: center;
  &.is-active {
    border-bottom: 2px solid $global-primary-color;
    color: $global-primary-color;
    /* background-color: #fff; */
  }
}

.is-img-mode {
  .brand-item {
    margin: 0;
    border-bottom: none;
  }
}

.brand-item.is-active .brand-icon {
  border-color: #05B570;
  /* box-shadow: 0 0 38px rgba(0,0,0,.08) inset; */
}

.brand-icon {
  width: 92px;
  height: 45px;
  background-repeat: no-repeat;
  background-size: 85%;
  background-position: center;
  position: relative;
  padding: 10px;
  border: 1px solid #EBEBEB;
  margin-right: 15px;
  margin-bottom: 14px;

  &:hover {
    border-color: #05B570;
    /* box-shadow: 0 0 38px rgba(0,0,0,.08) inset; */
  }
}

.active-info {
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translateX(-50%) scale(.7);
  min-width: 58px;
  font-size: 10px;
  background-color: #F79A47;
  border: 1px solid #F79A47;
  white-space:nowrap;
}

@media (--sm-viewport) {
  .brand-item {
    float: none;
    width: 80px;
    height: 50px;
    margin: 0;
    line-height: 50px;
    text-align: center;
    border: none;
    &.is-active {
      border: none;
    }
  }

  .active-info {
    line-height: 1.6;
    top: auto;
    bottom: -6px;
    min-width: 85%;
    background-color: rgba(247,154,71,0.15);
    color: #F79A47;
  }
}
</style>



// WEBPACK FOOTER //
// src/core/brands/brands.vue